<div class="support-details-view-container" *ngIf="supportObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="id-info">
    <mat-form-field appearance="fill" color="accent">
      <mat-label>ID</mat-label>
      <input matInput placeholder="ID" [disabled]="true" [value]="supportObject.recordId?.toString()">
    </mat-form-field>
  </div>

  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + supportObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="supportObject.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).corporation.write || supportObject.status?.key === 'closed'" (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
    <button *ngIf="supportObject.status?.key === 'closed'" [disabled]="!(userPermissions | async).corporation.delete || supportObject.status?.key === 'during'" (click)="changeToDuringStatus()" mat-stroked-button color="primary"><mat-icon>replay</mat-icon> <span> W toku</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card >
        <div fxLayout="row">
          <h3>Dane</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <app-detail header="Osoba zgłaszająca" [value]="supportObject.clientType.name"></app-detail>
          </div>
          <div fxFlex="50">
            <app-detail header="Forma kontaktu" [value]="supportObject.typeOfReport.name"></app-detail>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column" >
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Osoba zgłaszająca</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">

          <div fxFlex="50" >
            <app-detail header="Partner" [value]="supportObject.partner?.shortName"
                        [link]="supportObject.partner ? ['/partnerzy/szczegoly', supportObject.partner.uuid] : undefined"></app-detail>
          </div>

          <div fxFlex="50" >
            <app-detail header="OFWCA" [value]="supportObject.ofwca?.fullName"
                        [link]="supportObject.ofwca ? ['/ofwca/szczegoly', supportObject.ofwca.uuid] : undefined"></app-detail>
          </div>

        </div>
      </mat-card>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Rodzaj aktywności</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div  fxFlex = "100">
            <app-detail header="Rodzaj aktywności" [value]="supportObject.typeOfActivity.name"></app-detail>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column" >
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>TU</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <table fxFlex="60"   >
            <tr *ngFor="let headers of supportObject.insuranceCompanys">

              <td> {{headers}}</td>

            </tr>
          </table>
        </div>
      </mat-card>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>

      <div fxLayout="row">
        <h3>Dane</h3>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" >
        <div fxFlex="100">
          <app-detail header="Produkt" [value]="supportObject.productType?.name"></app-detail>
        </div>
      </div>

      <div fxLayout="row" >
        <div fxFlex="100">
          <app-detail header="Dane klienta" [value]="supportObject.reasonForRefusal"></app-detail>

        </div>
      </div>

      <div fxLayout="row" >
        <div fxFlex="100">
            <app-detail-bool header="Czy zawarta polisa" [value]="supportObject.concludedPolicy"></app-detail-bool>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px"  *ngIf=" !supportObject.concludedPolicy">
          <div fxFlex="100">
            <app-detail header="Powód odmowy" [value]="supportObject.refusalReason?.name"></app-detail>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" *ngIf=" supportObject.concludedPolicy">
          <div fxFlex="100">
            <app-detail header="Numer polisy" [value]="supportObject.policyNumber"></app-detail>
          </div>
        </div>

        <div fxLayout="row"   *ngIf=" supportObject.concludedPolicy">
          <div fxFlex="100">
           <app-detail header="TU" [value]="supportObject.company?.fullName"></app-detail>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px"   *ngIf=" supportObject.concludedPolicy">
          <div fxFlex="100">
            <app-detail header="Typ polisy" [value]="supportObject.policyType?.name"></app-detail>
          </div>
        </div>

        <div fxLayout="row"   *ngIf=" supportObject.concludedPolicy">
           <div fxFlex="100">
             <app-detail header="Przypis" [value]="supportObject.annotation"></app-detail>
           </div>
        </div>

       <div fxLayout="row" *ngIf=" supportObject.concludedPolicy">
          <div fxFlex="100" >

            <app-detail *ngIf="supportObject.policyEndAt " header="Data zakończenia polisy" [value]="supportObject.policyEndAt | date:'y-MM-dd'"></app-detail>

          </div>
        </div>
      </mat-card>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Notatka do rozmowy</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="100" [innerHTML]="supportObject.note "> </div>
<!--          <textarea fxFlex="100"  [value]="supportObject.note" [disabled]="true"  ></textarea>-->
        </div>
      </mat-card>
    </div>
  </div>
</div>
